module.exports = __webpack_public_path__ + "img/logo.f462eb70.png";